import React from 'react';
import { useTranslation } from 'react-i18next';
import { TCN } from '../../tcn/ui-kit/tokens';

/**
 * Module 4 — Mini horizontal distribution showing the count of creators per
 * activeness level (L1..L5). Pure SVG, no library.
 */
const ActivenessDistributionMini = ({ creators = [] }) => {
  const { t } = useTranslation();
  const buckets = [1, 2, 3, 4, 5].map((lvl) => ({
    level: lvl,
    count: creators.filter((c) => Number(c.activeness_level) === lvl).length,
  }));
  const max = Math.max(1, ...buckets.map((b) => b.count));

  return (
    <div>
      <div
        style={{
          fontSize: 11,
          fontWeight: 700,
          color: TCN.textDim,
          letterSpacing: '0.08em',
          textTransform: 'uppercase',
          marginBottom: 6,
        }}
      >
        {t('tcn.m4.dist.title', 'Activeness levels')}
      </div>
      <div style={{ display: 'flex', alignItems: 'flex-end', gap: 6, height: 44 }}>
        {buckets.map((b) => {
          const ratio = b.count / max;
          const h = Math.max(2, Math.round(ratio * 36));
          const color =
            b.level >= 4 ? TCN.green : b.level === 3 ? TCN.cyan : b.level === 2 ? TCN.amber : TCN.red;
          return (
            <div
              key={b.level}
              style={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                gap: 2,
                flex: 1,
              }}
              title={`L${b.level}: ${b.count}`}
            >
              <div
                style={{
                  width: '100%',
                  height: h,
                  background: color,
                  borderRadius: 4,
                  boxShadow: `0 0 4px ${color}88`,
                }}
              />
              <span
                style={{
                  fontSize: 10,
                  color: TCN.textDim,
                  fontVariantNumeric: 'tabular-nums',
                  fontFamily: TCN.fontMono,
                }}
              >
                {b.count}
              </span>
            </div>
          );
        })}
      </div>
      <div
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          marginTop: 4,
          fontSize: 9,
          color: TCN.textMute,
        }}
      >
        <span>L1</span>
        <span>L5</span>
      </div>
    </div>
  );
};

export default ActivenessDistributionMini;
